import { useNavigate } from 'react-router-dom';
import fullLogo from '../_Assets/Full_logo_TWB.svg';

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <img src={fullLogo} alt="Membify" className="legal-logo" />
          <button className="back-btn" onClick={() => navigate(-1)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 5l-7 7 7 7" />
            </svg>
            Tilbage
          </button>
        </div>

        <div className="legal-content">
          <h1>Vilkår og betingelser</h1>
          <p className="legal-date">Sidst opdateret: 28. april 2026</p>

          <section>
            <h2>1. Accept af vilkår</h2>
            <p>Ved at oprette en konto eller bruge Membify's tjenester accepterer du disse vilkår og betingelser. Hvis du ikke accepterer vilkårene, bedes du undlade at bruge tjenesten.</p>
          </section>

          <section>
            <h2>2. Om tjenesten</h2>
            <p>Membify er en platform til administration af medlemskaber, abonnementer og betalinger. Vi forbeholder os retten til at ændre, suspendere eller lukke dele af tjenesten med rimeligt varsel.</p>
          </section>

          <section>
            <h2>3. Oprettelse af konto</h2>
            <p>For at bruge Membify skal du:</p>
            <ul>
              <li>Være mindst 18 år gammel</li>
              <li>Angive korrekte og opdaterede oplysninger</li>
              <li>Holde dine loginoplysninger fortrolige</li>
              <li>Straks underrette os ved mistanke om uautoriseret adgang til din konto</li>
            </ul>
            <p>Du er ansvarlig for al aktivitet, der foregår under din konto.</p>
          </section>

          <section>
            <h2>4. Brug af tjenesten</h2>
            <p>Du forpligter dig til ikke at:</p>
            <ul>
              <li>Bruge tjenesten til ulovlige formål</li>
              <li>Forsøge at kompromittere platformens sikkerhed</li>
              <li>Videresælge eller overdrage din adgang til tredjepart</li>
              <li>Uploade indhold, der krænker tredjeparters rettigheder</li>
              <li>Forstyrre andres brug af tjenesten</li>
            </ul>
          </section>

          <section>
            <h2>5. Betaling og abonnement</h2>
            <p>Betaling for Membify's tjenester sker forud for den valgte periode. Priser er angivet inkl. moms, medmindre andet fremgår. Vi forbeholder os retten til at justere priser med 30 dages varsel.</p>
            <p>Ved manglende betaling forbeholder vi os retten til midlertidigt at suspendere adgangen til tjenesten.</p>
          </section>

          <section>
            <h2>6. Fortrydelsesret og opsigelse</h2>
            <p>Som forbruger har du 14 dages fortrydelsesret fra oprettelsen af din konto. Du kan til enhver tid opsige dit abonnement med virkning fra udgangen af den igangværende periode. Opsigelse sker via kontoindstillinger eller ved henvendelse til support.</p>
          </section>

          <section>
            <h2>7. Immaterielle rettigheder</h2>
            <p>Alt indhold på platformen, herunder logo, design, kode og tekst, tilhører Membify ApS og er beskyttet af ophavsret. Du må ikke kopiere, ændre eller distribuere dette uden skriftlig tilladelse.</p>
            <p>Du beholder rettighederne til det indhold, du selv uploader til platformen, og giver Membify en begrænset licens til at vise og levere dette indhold som en del af tjenesten.</p>
          </section>

          <section>
            <h2>8. Ansvarsbegrænsning</h2>
            <p>Membify leveres "som den er". Vi garanterer ikke uafbrudt eller fejlfri drift. Membify ApS er ikke ansvarlig for indirekte tab, driftstab eller tab af data, medmindre tabet skyldes grov uagtsomhed fra vores side.</p>
            <p>Vores samlede ansvar er under alle omstændigheder begrænset til det beløb, du har betalt for tjenesten i de seneste 3 måneder.</p>
          </section>

          <section>
            <h2>9. Tredjepartstjenester</h2>
            <p>Membify kan integrere med eller linke til tredjepartstjenester. Vi er ikke ansvarlige for indhold, funktionalitet eller privatlivspraksis hos sådanne tjenester og anbefaler, at du læser deres vilkår.</p>
          </section>

          <section>
            <h2>10. Ændringer af vilkår</h2>
            <p>Vi forbeholder os retten til at ændre disse vilkår. Væsentlige ændringer vil blive kommunikeret via e-mail eller en meddelelse på platformen med mindst 14 dages varsel. Fortsat brug af tjenesten efter ikrafttrædelsesdatoen betragtes som accept af de opdaterede vilkår.</p>
          </section>

          <section>
            <h2>11. Lovvalg og værneting</h2>
            <p>Disse vilkår er underlagt dansk ret. Eventuelle tvister, der ikke kan løses i mindelighed, afgøres ved de danske domstole med Københavns Byret som første instans.</p>
          </section>

          <section>
            <h2>12. Kontakt</h2>
            <p>Har du spørgsmål til vilkårene, er du velkommen til at kontakte os:</p>
            <ul>
              <li>E-mail: <a href="mailto:legal@membify.dk">legal@membify.dk</a></li>
              <li>Membify ApS, København, Danmark</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
